import InputLabel from "@material-ui/core/InputLabel";

export const FormInputLabel = ({ text, required = false }: any) => {
  return (
    <InputLabel className="formSearch__label-text">
      {text}
      {required ? (
        <span className="red">
          <strong>*</strong>
        </span>
      ) : (
        <span className="red" style={{ visibility: "hidden" }}>
          <strong>*</strong>
        </span>
      )}
    </InputLabel>
  );
};
